import styled from 'styled-components';
import { ContainerRef } from '../../styles';


export const Container = styled(ContainerRef)`
width: 100%;
span {
    color: #333 !important;
}

`;